import * as yup from "yup";

export default yup.object().shape({
  reason: yup.string().required(),
  note: yup
    .string()
    .when("reason", (val: string) => (val.toLocaleLowerCase() === "other" ? yup.string().required() : yup.string())),
});
